module.exports = __webpack_public_path__ + "img/26_67.a404708c.png";